// src/app/utils/axiosInterceptors.tsx
import { useAuth } from 'app/context/auth-context';
import axios from 'axios';
import { useEffect } from 'react';

export const useAxiosInterceptor = () => {
  const { logout, user } = useAuth();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          console.warn('401 detected, logging out...');

          try {
            await logout(user?.organizationId, user?.id ?? 0);
          } catch (err) {
            console.error('Logout failed', err);
          }

          // redirect to login
          window.location.href = '/auth';
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [logout, user]);
};
